import Airplane from "../../img/svgs/Airplane";

const Spinner = (props) => {
    return <>
        <div style={{ width: '300px', height: 150 }} className="btn bg-lev text-light" type="button" >
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {props.mensagem}
            <Airplane />
        </div>
    </>
}

export default Spinner;